import { t } from "../../i18n";

/** A picture chosen for the next text, not yet shrunk or uploaded. */
export interface PickedPhoto {
  id: string;
  file: File;
  /** An object URL for the thumbnail; revoked when the photo goes. */
  preview: string;
}

/** The pictures waiting under the Texts card's box, each with its ✕. */
export function PickedPhotos({
  photos,
  onDrop,
}: {
  photos: PickedPhoto[];
  onDrop: (id: string) => void;
}) {
  if (photos.length === 0) return null;
  return (
    <div className="textphotos" aria-label={t("Pictures to send")}>
      {photos.map((photo) => (
        <span key={photo.id} className="textphoto">
          <img src={photo.preview} alt={photo.file.name} />
          <button
            type="button"
            aria-label={t("Remove {name}", { name: photo.file.name })}
            title={t("Remove")}
            onClick={() => onDrop(photo.id)}
          >
            ✕
          </button>
        </span>
      ))}
    </div>
  );
}
